import axiosInstance from "../../axiosInstance";

const BASE_URL = "/system/teacher-support/admin";

export const getAdminTeacherSupportList = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};

export const getAdminTeacherSupportDetail = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const updateAdminTeacherSupport = async (id, data) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}`, data);
  return res.data;
};
